module.exports = __webpack_public_path__ + "img/hero-thumb-8.a5b7c443.png";